import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.currentSession()?.sessionToken;

  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { 'X-Approval-Session': token },
    }),
  );
};
